// RADAR OPERATIVO · RESIDENCIAL — orden y filtros VISUALES, lógica pura (sin React, sin red).
// El orden inicial es la PRIORIDAD OPERATIVA que ya resuelve el backend (`categoria` + su clave de
// orden): aquí NO se recalcula prioridad. «Nombre» y «Sitio» son reordenaciones de presentación y
// no cambian roles, asignación de casos ni ownership.
export const ORDENES_RES = [
  { v: "prioridad", t: "Prioridad" },
  { v: "nombre", t: "Nombre" },
  { v: "sitio", t: "Sitio" },
];
export const MODOS_RES = [
  { v: "todas", t: "Toda la cartera" },
  { v: "mi_vista", t: "Mi vista" },
  { v: "con_caso", t: "Con caso activo" },
];

const cmp = (a, b) => String(a || "").localeCompare(String(b || ""), "es", { sensitivity: "base" });
// Las personas sin nombre en el padrón («(sin nombre)», «—») se leen al FINAL cuando se ordena por
// nombre: es presentación, no una corrección del registro.
const SIN_NOMBRE = new Set(["", "—", "(sin nombre)"]);
const rankNombre = (p) => (SIN_NOMBRE.has(String(p?.nombre || "").trim()) ? 1 : 0);

// Mantiene el orden del backend como desempate: dos personas del mismo sitio siguen leyéndose por
// prioridad operativa.
export function ordenarResidencial(personas, orden) {
  if (orden === "nombre") {
    return [...personas].sort((a, b) => rankNombre(a) - rankNombre(b) || cmp(a.nombre, b.nombre));
  }
  if (orden === "sitio") {
    return [...personas].sort((a, b) =>
      cmp(a.sitio_nombre || a.ciudad, b.sitio_nombre || b.ciudad)
      || rankNombre(a) - rankNombre(b) || cmp(a.nombre, b.nombre));
  }
  return personas;   // prioridad operativa: el orden ya resuelto por el read-model
}

// Búsqueda SÓLO con campos ya autorizados del read-model residencial (nombre, sitio, ciudad).
export function coincide(p, ql) {
  if (!ql) return true;
  return [p.nombre, p.sitio_nombre, p.ciudad].filter(Boolean)
    .some((campo) => campo.toLowerCase().includes(ql));
}

export function filtrarResidencial(personas, { q = "", modo = "todas", miVista = [] } = {}) {
  const ql = q.trim().toLowerCase();
  const favoritos = new Set(miVista || []);
  return personas.filter((p) => {
    if (!coincide(p, ql)) return false;
    if (modo === "mi_vista") return favoritos.has(p.id);
    if (modo === "con_caso") return !!p.caso;
    return true;
  });
}
